'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import type { TopNavV6Violator } from '@src/components/TopNavV6/TopNavV6Props';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
export const TopNavV6Tile = props => {
  const $ = _c(30);
  const {
    tile
  } = props;
  const trackSelectNavCta = useTrackSelectNavCta();
  let t0;
  if ($[0] !== tile) {
    t0 = tile?.image && <Image className="object-cover" src={tile.image} alt={tile?.alt ?? ""} fill={true} />;
    $[0] = tile;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="relative mb-2 aspect-3/2 w-full overflow-hidden rounded-[30px] bg-bodi-gray-medium">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== tile) {
    t2 = tile?.stamp && <div className="w-fit text-bodi-accent-bright-500">{tile.stamp}</div>;
    $[4] = tile;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = tile?.title;
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="w-fit text-white">{t3}</div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t4) {
    t5 = <>{t1}{t2}{t4}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const content = t5;
  if (tile?.href) {
    const t6 = tile?.newTab ? "noopener noreferrer" : "";
    const t7 = tile?.newTab ? "_blank" : "_self";
    let t8;
    if ($[12] !== tile || $[13] !== trackSelectNavCta) {
      t8 = () => {
        trackSelectNavCta({
          "cta url": tile.href
        });
        tile?.onClick?.();
      };
      $[12] = tile;
      $[13] = trackSelectNavCta;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    let t9;
    if ($[15] !== content || $[16] !== t6 || $[17] !== t7 || $[18] !== t8 || $[19] !== tile.href) {
      t9 = <LocalizedLink rel={t6} target={t7} href={tile.href} className="w-full font-medium" onClick={t8}>{content}</LocalizedLink>;
      $[15] = content;
      $[16] = t6;
      $[17] = t7;
      $[18] = t8;
      $[19] = tile.href;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    return t9;
  }
  let t6;
  let t7;
  if ($[21] !== tile) {
    t6 = () => {
      tile?.onClick?.();
    };
    t7 = e => {
      if ((e.key === "Enter" || e.key === " ") && tile?.onClick) {
        e.preventDefault();
        tile.onClick();
      }
    };
    $[21] = tile;
    $[22] = t6;
    $[23] = t7;
  } else {
    t6 = $[22];
    t7 = $[23];
  }
  const t8 = tile?.onClick ? "button" : undefined;
  const t9 = tile?.onClick ? 0 : undefined;
  let t10;
  if ($[24] !== content || $[25] !== t6 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t10 = <div className="w-full font-medium" onClick={t6} onKeyDown={t7} role={t8} tabIndex={t9}>{content}</div>;
    $[24] = content;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};